import React from 'react';
import { Unlock, X } from 'lucide-react';

export const WelcomeUnlockedBanner = ({ onDismiss }) => (
  <div className="border-b border-emerald-200 bg-emerald-50 animate-[fadeInUp_0.4s_ease-out]" data-testid="strategy-welcome-banner">
    <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3 sm:px-6 lg:px-8">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-600 text-white"><Unlock className="h-4 w-4" /></span>
      <p className="flex-1 text-sm text-emerald-900">
        <span className="font-semibold">Welcome, your report is unlocked.</span> Answer a few quick questions below and we'll build your personalized strategy report.
      </p>
      <button onClick={onDismiss} aria-label="Dismiss welcome message" className="rounded-full p-1 text-emerald-700 transition-colors hover:bg-emerald-100" data-testid="strategy-welcome-dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  </div>
);

export default WelcomeUnlockedBanner;
